import { useFormik } from 'formik';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import * as yup from 'yup';
import ModalLoading from '../../../../../components/modalLoading';
import { ACCOUNT_IS_LOCKED } from '../../../../../utils/constants';
import { clearErrorSendMail, sendMail } from '../../../redux/action';
import './index.css';

function SendMail({setMail, setStep}) {
  const dispatch = useDispatch();   
  const navigate = useNavigate();

  const [account, isSendingMail, isSentMailSuccess, isSentMailFail, errorSendMail] = useSelector((state) => [
    state.account.account,
    state.account.isSendingMail,
    state.account.isSentMailSuccess,
    state.account.isSentMailFail,
    state.account.errorSendMail,
  ]);

  
  useEffect(() => {
    if (isSentMailSuccess) {
      setStep();
      dispatch(clearErrorSendMail());
    }
  }, [isSentMailSuccess]);

  
  const onSendMail = (data) => {
    const newData = {
      ...data,
      email: data.email.toLowerCase(),
    }
    setMail(newData.email);
    dispatch(sendMail(newData));
  };
  
  const sendMailValidationSchema = yup.object().shape({
    email: yup
    .string()
    .email('Email không đúng định dạng. Vui lòng kiểm tra lại')
    .required('Chưa nhập email')
    .test('server', 'Email không đúng định dạng.', val => (val && val.toLowerCase().split('@').pop() === 'fpt.com.vn' || val && val.toLowerCase().split('@').pop() === 'fpt.com')),
  });

  const {
    values,
    errors,
    touched,
    isValid,
    handleChange,
    handleBlur,
    handleSubmit,
    setFieldValue,
  } = useFormik({
    initialValues: {
      email: '',
    },
    validationSchema: sendMailValidationSchema,
    onSubmit: onSendMail,
  });

  useEffect(() => {
    if (isSentMailFail) {
      dispatch(clearErrorSendMail());
    }
  }, [values.email]);

  return (

    <div className="body">
      <img className='big_bg' src="/login/big_bg.png" alt=""/>
      <div className="mycontainer"> 
          <img className='frame' src="/login/bg-send-mail.png" alt=""/>
          <div className="content_lg">
            <h2 style={{color: "#499aaf"}} className="text-uppercase">Istorage</h2>
            <p style={{fontSize: "18px", color: "#499aaf", fontStyle: "italic"}}>Hệ thống upload và lưu trữ file</p>
            <form onSubmit={(e) => {e.preventDefault()}}>
              <div className={isSentMailFail ? "input-icons-error" : "input-icons"}>
                <i className="fal fa-envelope icon-mail"></i>
                <input 
                  className="input-field" 
                  type="email" 
                  placeholder="example@fpt.com"
                  value={values.email}
                  onChange={handleChange('email')}
                  onBlur={handleBlur('email')}
                />
                {values.email !== '' && 
                <i 
                  className="fas fa-times-circle icon-mail icon-right"
                  onClick={() => {
                    setFieldValue('email', '');
                  }}
                ></i>
                }
              </div>
              <div className="error">
                <small>{isSentMailFail ? errorSendMail : ''}</small>
              </div>
              <button 
                className={!isValid || isSendingMail || values.email === '' ? 'button' : 'button active'} 
                disabled={!isValid || isSendingMail || values.email === ''}
                onClick={handleSubmit}
              >
                <i className="fa fa-arrow-right"></i>
               </button>
            </form>
        </div>
      </div>
      <ModalLoading show={isSendingMail} content={'Đang xử lý...'}></ModalLoading>
    </div>
  
  );
}

export default SendMail;